import { createSlice } from "@reduxjs/toolkit";

export const infestationLevelListSlice = createSlice({
  name: "infestationLevelListSlice",
  initialState: {
    infestationLevelList: [],
  },
  reducers: {
    setInfestationLevelList: (currentSlice, action) => {
      currentSlice.infestationLevelList = action.payload;
    },
  },
});

export const { setInfestationLevelList } = infestationLevelListSlice.actions;
export const infestationLevelListReducer = infestationLevelListSlice.reducer;
